import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-common-import-confirm-dialog",
  templateUrl: "./common-import-confirm-dialog.component.html",
  styleUrls: ["./common-import-confirm-dialog.component.scss"],
  standalone: false
})
export class CommonImportConfirmDialogComponent {
  public static readonly defaultDialogHeight: string = "280px";
  public static readonly defaultDialogWidth: string = "450px";

  constructor(
    public dialogRef: MatDialogRef<CommonImportConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: { fileName: string }
  ) {}

  public confirm(): void {
    this.dialogRef.close(true);
  }
}
